import React, { Component } from 'react';

class ReviewInvoiceList extends Component {
    constructor(props) {
        super(props);
    }

    approveInvoice = (e, invoice) => {
        axios
            .patch(this.props.invoiceUrl.replace('actionOrId', `review/${invoice.id}`))
            .then(() => {
                toastr.success('Invoice marked as reviewed');
                setTimeout(() => {
                    if (this.props.onInvoiceApproved) {
                        this.props.onInvoiceApproved(invoice.id);
                    }
                }, 1200);
            })
            .catch(() => {
                toastr.error('Something went wrong');
            });
    };

    render() {
        let invoices = this.props.data.map((invoice, index) => {
            return (
                <tr key={index}>
                    <td>{invoice.id}</td>
                    <td>
                        {invoice.invoiceable_type === 'App\\Models\\ServiceProvider'
                            ? 'Provider'
                            : invoice.invoice_group_id
                              ? 'Group'
                              : 'Customer'}
                    </td>
                    <td>
                        {invoice.invoiceable_type === 'App\\Models\\ServiceProvider'
                            ? invoice.invoiceable.name
                            : invoice.invoiceable.customer.name}
                    </td>
                    <td>{moment(invoice.created_at).format('DD/MM/YYYY')}</td>
                    <td>
                        <a
                            href={this.props.downloadUrl
                                .replace(
                                    'customer:id',
                                    invoice.invoiceable_type === 'App\\Models\\ServiceProvider'
                                        ? invoice.invoiceable.id
                                        : invoice.invoiceable.customer.id
                                )
                                .replace('invoice:id', invoice.id)}
                            className="d-block"
                        >
                            {invoice.name}
                        </a>
                    </td>
                    <td>
                        <a
                            href={this.props.invoiceUrl?.replace('actionOrId', invoice.id)}
                            className="text-info"
                            title="View Invoice"
                        >
                            <i className="fas fa-eye mr-1"> </i>
                        </a>
                        <button
                            style={{
                                padding: 0,
                                marginBottom: '5px',
                                marginRight: '4px',
                                border: 0,
                                marginLeft: '10px',
                            }}
                            onClick={(e) => this.approveInvoice(e, invoice)}
                            className="btn btn-link btn-success"
                            title="Approve"
                        >
                            <i className="fas fa-check mr-12"></i>
                        </button>
                        <button
                            style={{
                                padding: 0,
                                marginBottom: 0,
                                marginRight: '4px',
                                border: 0,
                            }}
                            onClick={() => this.props.onReproduceInvoice(invoice)}
                            className="btn btn-link text-danger"
                            title="Reproduce Invoice"
                        >
                            <i className="fas fa-recycle mr-12"></i>
                        </button>
                    </td>
                </tr>
            );
        });
        return (
            <>
                <table className="table transform-text">
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Invoice type</th>
                            <th>Recipient name</th>
                            <th>Created</th>
                            <th>Download</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>{invoices}</tbody>
                </table>
            </>
        );
    }
}

export default ReviewInvoiceList;
